import React from 'react'
import propTypes from 'prop-types'
import Box from '@material-ui/core/Box'

import { Modal, ModalHeader, ModalSubHeader, ModalContent } from './index'
import { Button } from '../Button'

export const GenericErrorModal = ({ open, close }) => {
  return (
    <Modal open={open} onClose={close}>
      <ErrorModalContent onClose={close} />
    </Modal>
  )
}

// NOTE: For some reason, when this is rendered from './index.jsx', I can't seem to import and use ModalHeader, and ModalSubHeader.
// Instead, I just re-wrote the markup here. It might be because of some cyclic importing between
// ./index.jsx and GenericErrorModal.jsx
export const ErrorModalContent = ({ onClose }) => {
  return (
    <>
      <div className={`modal__header`}>
        <h1>
          Sorry, something went wrong...
        </h1>
      </div>
      <div className={`modal__sub-header`}>
        <h3>
          Don't worry! We've already been notified that you've experienced a problem.
        </h3>
      </div>
      <ModalContent>
        <p className='text-center'>
          If you wish to reach out to give us some extra information, you can click the 'Feedback' button at the bottom of your screen or email support at <a href='mailto: help@wealthbit.co'>help@wealthbit.co</a>.
        </p>
        <Box
          display='flex'
          justifyContent='center'
        >
          <Button primary onClick={onClose}>Close</Button>
        </Box>
      </ModalContent>
    </>
  )
}

GenericErrorModal.propTypes = {
  open: propTypes.bool.isRequired,
  close: propTypes.bool
}
